import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

interface FormSectionProps {
  title: string
  description: string
  children: ReactNode
  actions?: ReactNode
  direction?: 'row' | 'column'
}

export function FormSection({ title, description, children, actions, direction = 'row' }: FormSectionProps) {
  return (
    <div className='flex flex-col gap-6 @container w-full'>
      <div className={cn('flex flex-col gap-4 w-full', direction === 'row' ? '@lg:flex-row' : '')}>
        <div className='flex flex-col gap-2 w-full max-w-md'>
          <p className='text-xl leading-7 font-medium text-neutral-800'>{title}</p>
          <p className='text-base leading-6 font-normal text-neutral-500 break-words'>{description}</p>
          {actions}
        </div>
        <div className='flex flex-col gap-4 w-full flex-1'>{children}</div>
      </div>
    </div>
  )
}
